import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-65d7cf30")
const _hoisted_1 = ["for"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " Choose ", -1)
const _hoisted_3 = ["download", "href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-download" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-button-label" }, " ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "p-ink" }, null, -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      class: _normalizeClass(["p-button p-component p-fileupload-choose", _ctx.$attrs.class]),
      for: _ctx.id
    }, [
      _createElementVNode("div", null, [
        _createVNode(_component_FaIcon, {
          class: "p-mr-2",
          icon: "upload",
          size: "1x"
        }),
        _hoisted_2
      ]),
      _createElementVNode("input", _mergeProps({
        hidden: "",
        ref: "fileInput"
      }, _ctx.$attrs, {
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
        type: "file",
        multiple: false
      }), null, 16)
    ], 10, _hoisted_1),
    (_ctx.fileUrl)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          download: _ctx.file?.name,
          href: _ctx.fileUrl,
          class: "p-button p-component p-button-icon-only p-button-text p-button-primary"
        }, _hoisted_7, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.file?.name)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          icon: "pi pi-times",
          class: "p-button-text p-button-danger",
          onClick: _ctx.removeFile
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}